import { useState, useEffect, useCallback } from 'react';

export const useEventContent = (url: string) => {
  const [content, setContent] = useState('');

  // ref:
  // https://stackoverflow.com/questions/46802329/how-to-load-content-for-external-url-in-react/46803191
  const loadData = useCallback(() => {
    fetch(url)
      .then(function (response) {
        if (response.ok) {
          return response.text();
        }
        throw new Error('Error message.');
      })
      .then(
        function (data) {
          setContent(data);
        }.bind(this)
      )
      .catch(function (err: Error) {
        console.log('failed to load ', url, err.message);
      });
  }, [url]);

  useEffect(() => {
    loadData();
  }, [loadData, url]);

  return { content };
};
